import {
	object as zodObject,
	enum as zodEnum,
	array as zodArray,
	type infer as zodInfer,
	boolean as zodBoolean,
	string as zodString,
} from 'zod/mini';

import type { FeatureFlagName } from './FeatureFlagNames';

const HEADER_WIDGET_PLACEMENT_SCHEMA = zodEnum(['primary', 'secondary']);

const WIDGET_KEYS_SCHEMA = zodEnum([
	'Mrn',
	'LastVisit',
	'PatientInfo',
	'DateAndGender',
	'UpcomingVisit',
	'LastNavinaRun',
	'VisitDate',
	'ScrubDate',
	'Ascvd',
	'PatientStatus',
	'Allergies',
	'VisitType',
	'LastWellnessVisit',
	'ProviderName',
	'GroupPracticeName',
]);

export type WidgetKey = zodInfer<typeof WIDGET_KEYS_SCHEMA>;

const HEADER_WIDGET_SCHEMA = zodObject({
	key: WIDGET_KEYS_SCHEMA,
	placement: HEADER_WIDGET_PLACEMENT_SCHEMA,
});

// Only add flags that you want to validate and later consume from the FeatureFlag MobX model
export const ALL_FEATURE_FLAGS_SCHEMA = zodObject({
	configuration_CoreServices_PatientPortraitHeaderWidgets: zodArray(HEADER_WIDGET_SCHEMA),
	configuration_CoreServices_CoBrandingLogo: zodString(),
	ShowFeedbackButton: zodBoolean(),
	configuration_DxCapture_Show_Raf: zodBoolean(),
	configuration_DxCapture_portrait_without_sid_actions: zodBoolean(),
	configuration_DxCapture_disable_actions: zodBoolean(),
	configuration_DxCapture_yearSwitcher: zodBoolean(),
	configuration_DxCapture_patientWithoutAppointment: zodBoolean(),
} as const satisfies Partial<Record<FeatureFlagName, unknown>>);

export type AllFeatureFlags = zodInfer<typeof ALL_FEATURE_FLAGS_SCHEMA>;

export type HeaderWidget = zodInfer<typeof HEADER_WIDGET_SCHEMA>;
